import {db} from '../firebase'
import router from '../router'
import Vue from 'vue'

export default {
    namespaced: true,
    state:{
        techniques: [],
        currentTechnique: [],
    },
    mutations:{
        setTechniques(state, techniques){
            state.techniques = techniques   
        },
        setCurrentTechnique(state, technique){
            state.currentTechnique = technique
        }
    },
    actions:{
        async getTechniques({commit}){
            const techniquesRef = await db.collection("techniques").orderBy("order", "asc").get()
            var techniques = []
            techniquesRef.forEach((technique) => {
                techniques.push(technique.data())
            })
            commit('setTechniques', techniques)
        },
        async getTechniqueById(context, id){
            const technique = await db.collection('techniques').doc(id).collection('data').doc('single').get()
            if(technique.exists == false){
                return {}
            }else{
                return technique.data()
            }
        },
        async getTechnique({commit}, id){
            const technique = await db.collection('techniques').doc(id).collection('data').doc('single').get()
            if(technique.exists){
                commit('setCurrentTechnique', technique.data())
            }else{
                router.push({name: 'School'})
            }
        },
        async doUpdate(context, {id, title, description, thumbnail}){
            try{
                const techniqueRef = await db.collection('techniques').doc(id)
                techniqueRef.update({
                    title
                })
                
                techniqueRef.collection('data').doc('single').set({
                    title,
                    thumbnail,
                    description
                })

                Vue.$toast.success('La tecnicatura fue editada')
                router.push({name: 'Dashboard'})
            }catch(error){
                Vue.$toast.error('Hubo un problema al editar la tecnicatura, intenta nuevamente más tarde')
                console.error(error)
            }
        }
    }
}